<template>
  <div class="title" :class="type" @click="goDetail">
    <div class="border"></div>
    <span>{{title}}</span>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '查看更多'
    },
    type: {
      type: String,
      default: 'empty'
    },
    link: {
      type: String,
      default: ''
    },
  },
  methods: {
    goDetail () {
      if (this.link) {
        window.open(this.link, '_blank')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  display: block;
  margin: 0 auto;
  width: 249px; height: 44px;
  border-radius: 6px;
  text-align: center;
  line-height: 44px;
  cursor: pointer;
  @include isMobile {
    width: 204px;
    height: 34px;
    border-radius: 5px;
    line-height: 34px;
  }
  & span {
    @include font(20, 500);
    @include isMobile {
      @include font(17, 500);
    }
  }

  &.empty {
    position: relative;

    & .border {
      position: absolute; left: 0; top: 0;
      width: 100%; height: 100%;
      background: #FFF;
      border-radius: 6px;

      &::after {
        content: '';
        position: absolute;
        top: -1px; left: -1px; right: -1px; bottom: -1px;
        background: linear-gradient(to right, $blue, $green);
        border-radius: 6px;
        z-index: -1;
      }
    }

    & span {
      position: relative; z-index: 2;
      background-image: linear-gradient(to right, $blue, $green);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  &.solid {
    background: linear-gradient(to right, $blue, $green);
    color: #FFF;
  }

  &.white {
    background: white;
    color: $green;
  }
}
</style>